import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("pmv_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const CATEGORIES = [
    { key: "automobile", label: "Automobile" },
    { key: "mariage", label: "Mariage" },
    { key: "bapteme", label: "Baptême" },
    { key: "autres", label: "Autres" },
];

export const CATEGORY_LABEL = {
    automobile: "Automobile",
    mariage: "Mariage",
    bapteme: "Baptême",
    autres: "Autres",
};

export function resolvePhotoUrl(u) {
    if (!u) return null;
    if (u.startsWith("http")) return u;
    return `${BACKEND_URL}${u}`;
}
